﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as subjectModel from "~base/Services/API/Subject/Model";
import * as getSubjectByIdentifier from "~base/Services/API/Subject/GetSubjectByIdentifier";
import * as createSubject from "~base/Services/API/Subject/CreateSubject";
import * as api from "~base/Services/API";

//-------------------------------------------------------------------------------------
// API Methods
//-------------------------------------------------------------------------------------

export const ensureSubject = async (
    apiAdapter: api.ApiAdapter,
    subjectType: string,
    subjectIdentifier: string,
    subjectIdentifierType: string
): Promise<[subjectId?: number, errorResponse?: Response]> => {
    const getSubjectsResponse = await api.invokeApi<unknown>(
        apiAdapter,
        getSubjectByIdentifier.uri(subjectIdentifier, subjectIdentifierType),
        getSubjectByIdentifier.method,
        false
    );
    if (getSubjectsResponse.status == 200) {
        const getSubjectsResponseData: subjectModel.GetSubjectsResponse =
            await getSubjectsResponse.json();

        const matchingSubject = getSubjectsResponseData.items.find((x) =>
            x.subjectIdentifiers.some((y) => y.type == subjectIdentifierType)
        );

        if (!matchingSubject) {
            const createSubjectRequest: subjectModel.CreateSubjectRequest = {
                subjectType: subjectType,
                subjectIdentifiers: [
                    { type: subjectIdentifierType, value: subjectIdentifier },
                ],
            };
            const createdSubjectResponse =
                await api.invokeApi<subjectModel.CreateSubjectRequest>(
                    apiAdapter,
                    createSubject.uri,
                    createSubject.method,
                    false,
                    createSubjectRequest
                );
            if (createdSubjectResponse.status == 201) {
                const createdSubjectResponseData: subjectModel.CreateSubjectResponse =
                    await createdSubjectResponse.json();

                return [createdSubjectResponseData.id, null];
            } else {
                return [null, createdSubjectResponse];
            }
        } else {
            return [matchingSubject.id, null];
        }
    }

    return [null, getSubjectsResponse];
};
